//src/components/ImageCrop.jsx

import { useEffect } from 'react';
import { ImageCropModalContent } from './pic-image-crop-modal-content';
import { useImageCropContext } from './pic-image-crop-provider';
import React from 'react';

export const ImageCrop = ({ profilePicture, onClose, uploadImage, mode = 'edit' }) => {
  const { getProcessedImage, setImage, resetStates } = useImageCropContext();

  const handleDone = async () => {
    const avatar = await getProcessedImage();
    resetStates();
    uploadImage(avatar);
  };

  useEffect(() => {
    if (profilePicture) {
      const currentImage = profilePicture?.startsWith('data')
        ? profilePicture
        : `data:image/png;base64,${profilePicture}`;
      setImage(currentImage);
    } else {
      setImage(null);
    }
  }, [profilePicture, setImage]);

  return (
    <ImageCropModalContent
      profilePicture={profilePicture}
      handleDone={handleDone}
      handleClose={() => {
        if (profilePicture) {
          const currentImage = profilePicture?.startsWith('data')
            ? profilePicture
            : `data:image/png;base64,${profilePicture}`;
          setImage(currentImage);
        }
        onClose();
      }}
      mode={mode}
    />
  );
};

export default ImageCrop;
